import { useEffect, useState } from 'react'
import './usagealert.css'
import {
  getCookie,
  setCookie,
  isCookieConfirmed
} from '../cookiealert/CookieAlert'
import AppInfo from '@qiyo_components/AppInfo'
// https://www.geeksforgeeks.org/how-to-install-and-use-react-bootstrap-with-gatsby-js/
import { Container, Navbar, Nav, Button } from 'react-bootstrap'
import useSiteMetadata from '@qiyo_components/../helpers/useMySiteMetadata'

// Check if window is defined (so if in the browser or in node.js).
const isBrowser = typeof window !== "undefined"

const UsageAlert = () => {
  if (!isBrowser)
    return;
  
  const [show, setShow] = useState(false)
  const [retryCount, setRetryCount] = useState(0)
  const { disclaimer } = useSiteMetadata()

  useEffect(() => {
    setTimeout(() => {
      if (isCookieConfirmed()) {
        // console.log('UsageAlert-Timeout-1')
        setShow(true)
      } else if (retryCount < 20 * 5) {
        // console.log('UsageAlert-Timeout-2: retryCount=', retryCount)
        setRetryCount(retryCount + 1)
      } else {
        // console.log('UsageAlert-Timeout-3')
        setShow(true)
      }
    }, 5000)
  }, [retryCount])

  var usageAlert = document.querySelector('.usagealert')
  var acceptUsage = document.querySelector('.acceptusages')

  // console.log('UsageAlert-1: usageAlert=', usageAlert, ', show=', show, ', usage=', getCookie("acceptUsage"))

  // console.log('UsageAlert-1: acceptUsage=', acceptUsage)

//   setCookie("acceptUsage", false, 365);

  // console.log('UsageAlert-1-2')

  // usageAlert.offsetHeight; // Force browser to trigger reflow (https://stackoverflow.com/a/39451131)

  if (show) {
    var cookieValue = getCookie('acceptUsage')
    // console.log('UsageAlert-2: cookieValue=', cookieValue)

    // Show the alert if we cant find the "acceptUsage" cookie
    if (!cookieValue || cookieValue === 'false') {
      // console.log('UsageAlert-2-1')
      if (usageAlert) {
        usageAlert.classList.add('show')
      }
    }

    // When clicking on the agree button, create a 1 year
    // cookie to remember user's choice and close the banner
    acceptUsage &&
      acceptUsage.addEventListener('click', function () {
        setCookie('acceptUsage', true, 365)
        // setCookie('acceptUsage', true, 1)
        usageAlert && usageAlert.classList.remove('show')

        // dispatch the accept event
        window.dispatchEvent(new Event('cookieAlertAccept'))
      })
  }

  return (
    // <div className="d-flex d-lg-block flex-column bg-dark text-light text-center rounded-0 usagealert py-5 fs-2" >
    //     免責聲明：本網站之目的為提供資訊，非供交易或投資之目的，非供投資買賣建議，使用者須自負風險及盈虧，本公司不負任何責任。
    //     <a className="fw-bold text-hover-primary mx-3" href={`${AppInfo.baseName}/terms/disclaimer`} target='_blank' rel="noreferrer">
    //         詳閱《免責聲明》
    //     </a>

    //     <button type="button" className="btn btn-primary d-inline mx-auto ms-lg-5 acceptusages mt-5 mt-lg-0 fs-2">
    //         我同意
    //     </button>
    // </div >

    <div className='banner usagealert'>
      <Container className='container'>
      免責聲明：{disclaimer}
        <a
          className='fw-bold text-hover-primary mx-3'
          href={`${AppInfo.baseName}legal/disclaimer`}
          target='_blank'
          rel='noreferrer'
        >
          詳閱《免責聲明》
        </a>
        <Button variant='primary' className='acceptusages'>
          我同意
        </Button>
      </Container>
    </div>
  )
}

export default UsageAlert
